import { useContext } from 'react'

import {
  Button,
  Columns,
  LoadingModule,
  SaveFormModule,
} from '@domain-group/suit-theme'

import useTrainingModule, { useTrainingModuleForm } from '@hooks/useTrainingModule'

import PageContext from '@contexts/pageContext'

import PageLayout from '../../../../components/PageLayout'
import TrainingModuleTools from '../../../../components/TrainingModuleTools'

import TrainingLessons from '../TrainingLessons'
import TrainingModuleDetails from '../TrainingModuleDetails'
import TrainingModuleImage from '../TrainingModuleImage'

const PageContent = (props: { trainingModuleId: number}) => {
  const { trainingModuleId } = props

  const pageContext = useContext(PageContext)
  const {
    callbacks: {
      updateTrainingModule,
    },
  } = pageContext

  const trainingModulePayload = useTrainingModule({ id: trainingModuleId })
  const {
    trainingModule,
    callbacks: {
      updateTrainingModule: updateFn,
    },
    loading,
    updating,
    urls,
  } = trainingModulePayload

  const trainingModuleFormPayload = useTrainingModuleForm(trainingModule, { validateOn: 'change' })
  const { entityState, saveEnabled } = trainingModuleFormPayload

  const updateTrainingModulePayload = {
    callbacks: {
      action: updateFn,
    },
    entityParams: entityState,
    toastText: 'Training Module Updated',
  }

  return (
    <PageLayout entityPayload={trainingModulePayload} activeTabBarItemKey="details">
      <Columns.Main>
        <LoadingModule loading={loading} times={3} />

        {!loading && (
          <>
            <TrainingModuleDetails
              trainingModuleFormPayload={trainingModuleFormPayload}
              urls={urls}
            />

            <TrainingLessons trainingModuleId={trainingModuleId} />

            <SaveFormModule>
              <Button
                buttonStyle="primaryCreate"
                disabled={!saveEnabled}
                loading={updating}
                marginLeft="auto"
                onClick={() => updateTrainingModule(updateTrainingModulePayload)}
                size="medium"
              >
                Save Details
              </Button>
            </SaveFormModule>
          </>
        )}
      </Columns.Main>

      <Columns.Sidebar>
        <TrainingModuleImage trainingModulePayload={trainingModulePayload} />

        <TrainingModuleTools trainingModulePayload={trainingModulePayload} />
      </Columns.Sidebar>
    </PageLayout>
  )
}

export default PageContent
